import React from 'react';
import classes from './Button.module.scss'
const Button = props => {
    return (
        <button style={{backgroundColor: props?.backgroundColor ?? '#009DDC', marginTop : '5px'}} onClick={props.onClick} className={props.outlined ? classes.OutlinedButton : classes.MaterialButton}>{props.btnText}</button>
    );
}

export default Button;
